import{B as L}from"./chunk-BaseElement-QCmfBlzK.js";import{c as N}from"./chunk-constructorio-kL1h0Ctx.js";import{x as o,T as x}from"./chunk-lit-element-CULRVKo8.js";import{c as $}from"./chunk-repeat-CLr2jifB.js";import{t as j}from"./chunk-custom-element-BhZVzxrc.js";import{n as h}from"./chunk-property-BXqvfTtY.js";import"./chunk-constructorio-DDhIvy8f.js";import"./chunk-_commonjsHelpers-Cpj98o6Y.js";import"./chunk-directive-CF8sV3Lr.js";import"./chunk-directive-helpers-R4cBqjor.js";var E=Object.defineProperty,G=Object.getOwnPropertyDescriptor,g=(e,t,l,s)=>{for(var r=s>1?void 0:s?G(t,l):t,n=e.length-1,i;n>=0;n--)(i=e[n])&&(r=(s?i(t,l,r):i(r))||r);return s&&r&&E(t,l,r),r};let m=class extends L{constructor(){super(...arguments),this.textSort="",this.textFilter="",this.textFilterCounter="",this.textFiltersCounter="",this.textDataSeeResult="",this.textDataSeeResults="",this.textHideCount="",this.textViewAllCount="",this.textApply="",this.textClearAll="",this.dataResultsGridWithCountOne="",this.dataResultsGridWithCountOther="",this.type="",this.facetsCheckboxVisibleLimit=8,this.currentPage=1,this.resultsPerPage=16,this.resourcesData={},this.textFilterResults="",this._constructorResponseID=0}connectedCallback(){super.connectedCallback(),this.fetchAllResources()}async fetchAllResources(){try{const e=await this.getPaginatedResults();if(e){const{results:t,totalPages:l,facets:s,sortOptions:r,totalResults:n}=e;if(!t)return;const i=t.length>0?t.map(a=>{var c,p,f;return{handle:(c=a.data)==null?void 0:c.handle,type:((p=a.data)==null?void 0:p.type)??"",id:((f=a.data)==null?void 0:f.id)??""}}):[];this.resourcesData={sortOptions:r,facets:s,cards:i,paginationIds:Array.from({length:l},(a,c)=>c+1),totalResults:n};const u=this.getTotalFiltersApplied(this.resourcesData.facets);this.textFilterResults=u==0?this.textFilter:u>1?this.textFiltersCounter:this.textFilterCounter,u>0&&(this.textFilterResults=this.textFilterResults.replace("{{ count }}",String(u)))}}catch(e){console.error("Error fetching browse results:",e)}}async getPaginatedResults(e=1,t=16,l={},s=""){var r,n,i,u;try{const a=await N.browse({filterName:"type",filterValue:this.type,section:"Articles",resultsPerPage:t,page:e,filters:l,sortBy:s,sortOrder:s.includes("ascending")?"ascending":"descending"},{enabled:!0,expiryMs:12e4}),c=(r=a==null?void 0:a.response)==null?void 0:r.results,p=(n=a==null?void 0:a.response)==null?void 0:n.total_num_results,f=Math.ceil((p??1)/this.resultsPerPage),w=(i=a==null?void 0:a.response)==null?void 0:i.facets,d=(u=a==null?void 0:a.response)==null?void 0:u.sort_options;return{results:c,totalPages:f,currentPage:e,facets:w,sortOptions:d,totalResults:p}}catch(a){return console.error("Constructor.io pagination error:",a),null}}async filterChanged(e,t){var w;if(!e)return;const l=t==null?void 0:t.hasAttribute("target-clear-all-filters");if(t)if(t.id.toLowerCase().includes("mobile")){if(t.getAttribute("type")==="radio"){const d=document.querySelector('select[name="sort_by"]');d&&(d.value=t.value,d.dispatchEvent(new Event("change",{bubbles:!0})))}else{const d=t.id.replace("Mobile","Desktop"),y=document.getElementById(d);y&&(y.checked=t.checked,y.dispatchEvent(new Event("change",{bubbles:!0})))}return}else if(t.tagName.toLowerCase()==="select"){const d=document.querySelector(`[type="radio"][name="sort_by"][value="${t.value}"]`);d.checked=!0}else{const d=document.getElementById(t.id.replace("Desktop","Mobile"));d&&(t.type=="checkbox"?d.checked=t.checked:d.value=t.value)}const s=(w=e.querySelector("#SortOptionsFormDesktop select"))==null?void 0:w.value;let r=1;const n=e.querySelector("[aria-current='page']");n&&!t&&n.textContent&&(r=parseFloat(n.textContent));const i=parseFloat(e.getAttribute("data-pagination-results-per-page")),u=e.querySelector("[target-filters]"),a=new FormData(u),c={};for(const[d,y]of a.entries())c[d]?Array.isArray(c[d])?c[d].push(y):c[d]=[c[d],y]:c[d]=y;const p={};if(!l)for(const[d,y]of Object.entries(c))d!=="sort_by"&&(p[d]=y);this.scrollIntoView();const f=await this.getPaginatedResults(r,i,p,s);if(this._constructorResponseID++,f){const{results:d,totalPages:y,facets:F,sortOptions:M,totalResults:P}=f,C=d&&d.length>0?d.map(b=>{var v,S,_,R,A,D;return(v=b.data)!=null&&v.handle&&((S=b.data)!=null&&S.type)&&((_=b.data)!=null&&_.id)?{handle:(R=b.data)==null?void 0:R.handle,type:(A=b.data)==null?void 0:A.type,id:(D=b.data)==null?void 0:D.id}:{}}):[];if(!C)return;const z=(F==null?void 0:F.filter(b=>(b==null?void 0:b.type)==="multiple").map(b=>({...b,opened:Array.isArray(b.options)&&b.options.some(v=>v.status!=="")})))??[];this.resourcesData={sortOptions:M,cards:C,facets:z,paginationIds:Array.from({length:y},(b,v)=>v+1),totalResults:P};const k=this.getTotalFiltersApplied(this.resourcesData.facets);this.textFilterResults=k==0?this.textFilter:k>1?this.textFiltersCounter:this.textFilterCounter,k>0&&(this.textFilterResults=this.textFilterResults.replace("{{ count }}",String(k))),this.scrollIntoView({behavior:"smooth",block:"start"})}}paginateHandleClick(e){var r,n;const t=e.target,l=(n=(r=t.parentElement)==null?void 0:r.parentElement)==null?void 0:n.querySelectorAll("button:not([data-direction])"),s=parseInt(t==null?void 0:t.textContent);this.currentPage=s,l==null||l.forEach(i=>{var c;const a=parseInt((c=i.querySelector("span"))==null?void 0:c.textContent)==s;i.classList.toggle("border-t-foreground",a),i.classList.toggle("border-t-border",!a),a?(i.setAttribute("aria-current","page"),this.filterChanged(t.closest("search-results-section"))):i.removeAttribute("aria-current")})}paginateArrowClick(e){var r,n,i,u;const t=e.target,l=(n=(r=t.parentElement)==null?void 0:r.parentElement)==null?void 0:n.querySelector("[aria-current='page']"),s=(u=(i=t.parentElement)==null?void 0:i.parentElement)==null?void 0:u.querySelectorAll("button:not([data-direction])");if(l&&s&&t){const a=Array.from(s).indexOf(l),c=parseFloat(t==null?void 0:t.getAttribute("data-direction"));c>0&&a<s.length-1&&s[a+1].click(),c<0&&a>0&&s[a-1].click()}}applyFilterEvent(e){const t=e.target;this.currentPage=1,this.filterChanged(t.closest("search-results-section"),t)}clearAllFilters(e){e.preventDefault(),this.applyFilterEvent(e)}handleSelectChange(e){this.applyFilterEvent(e)}handleCheckboxChange(e){this.applyFilterEvent(e)}handleize(e){return e.toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-$/,"").replace(/^-/,"")}getTotalFiltersApplied(e){return(e==null?void 0:e.reduce((t,l)=>{const s=l.type!="range"?l.options.filter(r=>r.status==="selected").length:0;return t+s},0))||0}getFacetsHTML(e,t,l){var n,i,u;const s=this.getTotalFiltersApplied(e),r=s==0?this.textApply.replace("{{ count }}","0"):(((n=this.resourcesData)==null?void 0:n.totalResults)??0)>1?this.textDataSeeResults:this.textDataSeeResult;return o`
      <div class="flex h-full w-full flex-col">
        <div
          class="flex-grow${t=="Mobile"?" overflow-auto":x}"
        >
          ${$(e??[],a=>a.name+t+this._constructorResponseID,a=>{var c;return o` ${((c=a.display_name)==null?void 0:c.toLowerCase())!="type"?o` <details
                    class="group/details border-b border-t-border"
                    ?open="${t!="Mobile"||a.opened}"
                  >
                    <summary
                      class='focus-inset group/filter-dropdown md:after:content-[" "] relative flow-root cursor-pointer max-md:px-xs max-md:py-md md:pointer-events-none md:cursor-auto md:pb-xs md:pt-sm md:after:pointer-events-none md:after:absolute md:after:left-0 md:after:top-0 md:after:z-10 md:after:block md:after:h-full md:after:w-full'
                    >
                      <div
                        class="flex w-full items-center justify-between text-sm"
                      >
                        <span
                          class="${window.brand=="NG"?"text-t-foreground-secondary":""} text-heading-6 font-medium capitalize"
                          >${a.display_name}</span
                        >
                        <span class="hidden group-open/details:block">
                          <svg-icon
                            src="icon-minus"
                            class="block md:hidden"
                            style="--icon-size: 13px;"
                          ></svg-icon>
                        </span>
                        <span class="block group-open/details:hidden">
                          <svg-icon
                            src="icon-plus"
                            class="block md:hidden"
                            style="--icon-size: 13px;"
                          ></svg-icon>
                        </span>
                      </div>
                    </summary>
                    ${o`
                      ${a.type==="multiple"?o`
                            <div
                              class="group/facet max-md:px-xs max-md:pb-md md:pb-sm"
                            >
                              <ul class="list-unstyled space-y-2xs" role="list">
                                ${$(a.options,p=>p.value,(p,f)=>o` ${p.display_name!=""?o` <li
                                          class=${f>=this.facetsCheckboxVisibleLimit?'group-has-[toggle-button[data-toggled="false"]]/facet:hidden':""}
                                        >
                                          <div
                                            class="group/checkbox inline-flex items-center justify-start gap-x-xs"
                                          >
                                            <label
                                              class="relative flex cursor-pointer items-center overflow-clip rounded-[1px]"
                                              for="Filter-filter.p.${this.handleize(p.display_name)}-${t}-${f}"
                                            >
                                              <input
                                                type="checkbox"
                                                class="${window.brand=="NG"?"rounded-[2px] border-t-foreground-secondary":"border-blue-gray-200"} peer relative size-4 cursor-pointer appearance-none border transition-all checked:border-t-foreground disabled:border-t-border"
                                                id="Filter-filter.p.${this.handleize(p.display_name)}-${t}-${f}"
                                                value="${p.value}"
                                                name="${a.name}"
                                                aria-labelledby="Filter-filter.p.${this.handleize(p.display_name)}-${t}-${f}_label"
                                                .checked=${p.status!==""}
                                                @change=${this.handleCheckboxChange}
                                              />
                                              <span
                                                class="${window.brand=="NG"?"bg-t-foreground-secondary":"bg-p-darkest"} pointer-events-none absolute left-2/4 top-2/4 flex size-3 h-full w-full -translate-x-2/4 -translate-y-2/4 items-center justify-center text-p-lightest opacity-0 transition-opacity peer-checked:opacity-100 peer-disabled:border-t-border peer-disabled:text-t-border"
                                              >
                                                <svg-icon
                                                  src="icon-checkbox-tick"
                                                  class="block"
                                                  style="--icon-size: 12px;"
                                                ></svg-icon>
                                              </span>
                                            </label>
                                            <label
                                              class="text-body mt-px cursor-pointer select-none break-all capitalize text-t-foreground group-has-[:disabled]/checkbox:text-t-border"
                                              for="Filter-filter.p.${this.handleize(p.display_name)}-${t}-${f}"
                                            >
                                              ${p.display_name}
                                            </label>
                                          </div>
                                        </li>`:x}`)}
                              </ul>
                              ${a.options.length>this.facetsCheckboxVisibleLimit?o`
                                    <toggle-button
                                      role="button"
                                      data-toggled="false"
                                      class="group/toggle-button ${window.brand=="NG"?"text-t-foreground-secondary font-bold":"text-t-foreground"} text-utility-bold mt-md underline md:mt-xs"
                                    >
                                      <span
                                        class='group-data-[toggled="true"]/toggle-button:hidden'
                                        >${this.textViewAllCount.replace("{{ count }}",`${a.options.length}`)}</span
                                      >
                                      <span
                                        class='group-data-[toggled="false"]/toggle-button:hidden'
                                        >${this.textHideCount.replace("{{ count }}",`${a.options.length-this.facetsCheckboxVisibleLimit}`)}</span
                                      >
                                    </toggle-button>
                                  `:x}
                            </div>
                          `:x}
                    `}
                  </details>`:x}`})}
        </div>
        ${t=="Mobile"?o`
              <div
                class="group/toggle-clear-all flex w-full flex-col items-center justify-center gap-xs border-t border-t-border bg-t-background px-pagegridmargin py-sm"
                data-show-clear-all=${(s??0)>0}
              >
                <dialog-toggle modal-id="${l}" class="w-full">
                  <button class="btn w-full" variant="primary">
                    ${(r==null?void 0:r.replace("{{ count }}",((u=(i=this.resourcesData)==null?void 0:i.totalResults)==null?void 0:u.toString())??""))??""}
                  </button>
                </dialog-toggle>
                <button
                  class='text-utility-bold block cursor-pointer text-t-foreground underline group-data-[show-clear-all="false"]/toggle-clear-all:hidden'
                  target-clear-all-filters
                  @click=${this.clearAllFilters}
                >
                  ${this.textClearAll}
                </button>
              </div>
            `:x}
      </div>
    `}getSortHTML(e,t){return o`
      ${t=="Desktop"?o` <facet-filters-form
            section-id="facet-filters"
            data-mode="sort"
            class="max-md:hidden"
          >
            <form
              id="SortOptionsForm${t}"
              class="gap-2xs${window.brand=="TFC"?" !font-normal":""} text-utility-bold flex"
            >
              <label for="SortBy">${this.textSort}:</label>
              <div class="relative">
                <select
                  name="sort_by"
                  id="SortBy"
                  aria-describedby="a11y-refresh-page-message"
                  class="outline-none${window.brand=="TFC"?" bg-transparent":""} block w-full appearance-none pr-sm"
                  @change=${this.handleSelectChange}
                >
                  ${$(e??[],l=>l.sort_by+t,l=>{var s;return o`
                      <option
                        value="${l.sort_by}"
                        ${l.status!=""?' selected="selected"':""}
                      >
                        ${(s=l.display_name)==null?void 0:s.replace("Most Relevant","Featured")}
                      </option>
                    `})}
                </select>
                <svg-icon
                  src="icon-select-arrow"
                  class="pointer-events-none absolute right-0 top-2/4 -translate-y-2/4"
                  style="--icon-size: 16px;"
                ></svg-icon>
              </div>
            </form>
          </facet-filters-form>`:o` <facet-filters-form
            section-id="facet-filters"
            data-mode="sort"
            class="flex h-full"
          >
            <form
              id="SortOptionsForm${t}"
              class="flex w-full flex-col"
            >
              <div
                id="SortOptionsForm${t}_sort"
                class="group/facet max-md:px-pagegridmargin max-md:py-md md:pb-sm"
                sub-section-id="SortOptionsForm${t}_sort"
                data-sort-by="title-ascending"
              >
                <ul class="list-unstyled space-y-xs md:space-y-2xs" role="list">
                  ${$(e??[],l=>l.sort_by+t,l=>o`
                      <li class="py-2xs" data-selected="false">
                        <div
                          class="group/radio inline-flex items-start justify-start gap-x-xs"
                        >
                          <div
                            class="peer relative flex cursor-pointer items-center rounded-full"
                          >
                            <input
                              type="radio"
                              class="peer relative size-4 cursor-pointer appearance-none rounded-full border border-t-foreground-secondary text-t-foreground-secondary transition-all checked:border-t-foreground-secondary disabled:border-t-border"
                              id="sortoptionsform${t}_input_${l.sort_by}"
                              name="sort_by"
                              value="${l.sort_by}"
                              @change=${this.handleSelectChange}
                              .checked=${l.status!=""}
                            />
                            <span
                              class="pointer-events-none absolute left-2/4 top-2/4 -translate-x-2/4 -translate-y-2/4 scale-0 text-t-foreground opacity-0 transition-[opacity,transform-] peer-checked:scale-100 peer-checked:opacity-100"
                            >
                              <svg-icon
                                src="icon-radio-circle"
                                class="block"
                                style="--icon-size: 10px;"
                              ></svg-icon>
                            </span>
                          </div>
                          <label
                            class="mt-px cursor-pointer select-none"
                            for="sortoptionsform${t}_input_new-arrivals8"
                          >
                            <div>
                              <p
                                id="sortoptionsform${t}_input_new-arrivals8_label"
                                class="text-body block leading-none text-t-foreground group-has-[:disabled]/radio:text-t-disabled"
                              >
                                ${l.display_name.replace("Most Relevant","Featured")}
                              </p>
                            </div>
                          </label>
                        </div>
                      </li>
                    `)}
                </ul>
              </div>
            </form>
          </facet-filters-form>`}
    `}getPaginationArray(e,t){const s=[];if(s.push("1"),t<=6)for(let r=2;r<t;r++)s.push(r);else if(e<=3){for(let r=2;r<=4;r++)s.push(r);s.push("...")}else if(e>=t-2){s.push("...");for(let r=t-3;r<t;r++)s.push(r)}else s.push("..."),s.push(e-1),s.push(e),s.push(e+1),s.push("...");return s[s.length-1]!==t&&s.push(t),s.map(r=>r.toString())}getPaginateHTML(e,t=1){if(!e)return;const l=this.getPaginationArray(t,e.length);if(l)return o`
      ${(e==null?void 0:e.length)>1?o`
            <div class="flex justify-center px-lg pb-lg pt-md">
              <ul
                class="flex list-none items-center justify-center gap-2.5"
                role="list"
              >
                ${(e==null?void 0:e.length)>1?o`
                      <li class="inline-flex list-none">
                        <button
                          class="${t===1?"cursor-not-allowed opacity-40":""} flex h-11 items-center justify-center"
                          data-direction="-1"
                          ?disabled=${t===1}
                          aria-disabled="${t===1}"
                          @click=${this.paginateArrowClick}
                        >
                          <svg-icon
                            src="icon-caret"
                            class="pointer-events-none block"
                            style="--icon-size: 16px; rotate: 90deg;"
                          ></svg-icon>
                        </button>
                      </li>
                    `:x}
                ${$(l,s=>"productPage"+s,s=>o`
                    ${s!="..."?o`
                          <li class="inline-flex list-none">
                            <button
                              class="${s==t.toString()?`${window.brand=="NG"?"border-t-foreground-secondary bg-t-accent-04":"border-t-foreground"}`:"border-t-border"} ${window.brand=="NG"?"rounded-full":"rounded-sm"} flex h-11 w-11 items-center justify-center border"
                              aria-current="${s==t.toString()?"page":x}"
                              @click=${this.paginateHandleClick}
                            >
                              <span class="utility-standard pointer-events-none"
                                >${s}</span
                              >
                            </button>
                          </li>
                        `:o`
                          <li class="inline-flex list-none">
                            <span
                              class="${window.brand=="NG"?"rounded-full":"rounded-sm"} flex h-11 w-11 items-center justify-center border border-t-border"
                            >
                              <span class="utility-standard pointer-events-none"
                                >…</span
                              >
                            </span>
                          </li>
                        `}
                  `)}
                ${(e==null?void 0:e.length)>1?o`
                      <li class="inline-flex list-none">
                        <button
                          class="${t===e.length?"cursor-not-allowed opacity-40":""} flex h-11 items-center justify-center"
                          data-direction="1"
                          ?disabled=${t===e.length}
                          aria-disabled="${t===e.length}"
                          @click=${this.paginateArrowClick}
                        >
                          <svg-icon
                            src="icon-caret"
                            class="pointer-events-none block"
                            style="--icon-size: 16px; rotate: -90deg;"
                          ></svg-icon>
                        </button>
                      </li>
                    `:x}
              </ul>
            </div>
          `:x}
    `}removeFacet(e){const t=e.target;if(t.dataset.name=="price")this.currentPage=1,this.filterChanged(t.closest("collection-results-section"),t);else{const l=this.querySelector(`[target-filters][is-mobile] [name="${t.dataset.name}"][value="${t.dataset.value}"]`);l&&l.click()}}getFacetRemove(e,t){return o`
      <facet-remove
        class="flex cursor-pointer snap-center items-center gap-2xs whitespace-nowrap rounded-sm bg-t-background-secondary px-xs py-[0.438rem]"
        data-name="${e.name}"
        data-value="${e.display_name}"
        @click=${this.removeFacet}
      >
        <svg-icon
          src="icon-close"
          class="pointer-events-none block"
          style="--icon-size: 8px"
        ></svg-icon>
        <span
          class="text-utility-regular pointer-events-none text-t-foreground"
        >
          ${e.type=="range"?o`$${e.min} - $${e.max}`:e.name=="rating_tier"?o`
                  <div class="flex items-center gap-1">
                    ${$([1,2,3,4,5],l=>"star"+l+t,l=>l<=parseFloat(e.display_name)?o`<svg-icon
                              src="icon-star-full"
                              class="block text-t-accent-01"
                              style="--icon-size: 16px;"
                            ></svg-icon>`:o`<svg-icon
                              src="icon-star-empty"
                              class="block text-t-foreground-secondary"
                              style="--icon-size: 16px;"
                            ></svg-icon>`)}
                  </div>
                `:o`${e.display_name}`}
        </span>
      </facet-remove>
    `}getFilteredFacets(e,t){if(!(e!=null&&e.length))return o``;const l=(e==null?void 0:e.reduce((s,r)=>{if(r.type!=="range"){const n=r.options.filter(i=>i.status==="selected").map(i=>({...i,name:r.name}));return s.concat(n)}else{const n=Object.hasOwn(r.status,"min")&&Object.hasOwn(r.status,"max"),i=r.status.min!==r.min,u=r.status.max<(this._productsMaxPrice??r.max);return n&&(i||u)&&s.push({...r,min:r.status.min,max:r.status.max}),s}},[]))??[];return o`
      <div
        class="empty:pt-0${t=="Desktop"?" max-md:hidden":""} col-span-full w-full pt-sm empty:hidden"
        data-target-facet-removes="${t==null?void 0:t.toLowerCase()}"
      >
        ${l.length>0?o` <facet-filters-form
              section-id="facet-filters"
              class="[&amp;[loading]]:opacity-50 [&amp;[loading]]:pointer-events-none flex h-full w-full"
              data-mode="facet-removes"
              data-form-id="FacetRemovesForm${t}"
              data-filters-form-id="FacetFiltersForm${t}"
            >
              <form
                id="FacetRemovesForm${t}"
                class="${t=="Desktop"?"flex-wrap":"no-scrollbar overflow-x-auto snap-x snap-mandatory px-xs"} flex w-full items-center gap-2xs"
              >
                ${$(l??[],s=>s.name,s=>this.getFacetRemove(s,t))}
                ${t=="Desktop"?o`<facet-remove
                      class="text-utility-bold ml-2xs cursor-pointer text-t-foreground underline"
                      target-clear-all-filters
                      @click=${this.clearAllFilters}
                    >
                      ${this.textClearAll}
                    </facet-remove>`:x}
              </form>
            </facet-filters-form>`:x}
      </div>
    `}getModalDialog(e,t,l,s,r,n,i,u,a){return o`
      <modal-dialog
        cloak
        type="${r}"
        id="${e}"
        anchor="${t}"
        close-on-backdrop-click="true"
        drawer-classes="${a}"
        close-icon-size="${i}"
      >
        <h5 slot="header" class="${u} h6">${n}</h5>
        <div slot="additional-content">${s}</div>
        <form target-filters is-mobile class="h-full">${l}</form>
      </modal-dialog>
    `}render(){var e,t,l,s,r,n,i,u,a,c;return o` <search-results-section
      class="grid grid-cols-1 pb-sm 2xl:container md:grid-cols-[minmax(0,295px)_minmax(0,1fr)] md:gap-x-lg md:gap-y-xs md:px-pagemargin"
      data-pagination-results-per-page="${this.resultsPerPage}"
      target-content-results
      data-cnstrc-browse
      data-cnstrc-filter-name="type"
      data-cnstrc-filter-value="${this.type}"
      data-cnstrc-num-results="${((e=this.resourcesData)==null?void 0:e.totalResults)??0}"
    >
      ${this.getFilteredFacets(this.resourcesData.facets,"Desktop")}
      <aside class="md:block md:pb-6">
        <div class="max-md:hidden">
          <form target-filters>
            ${this.getFacetsHTML((t=this.resourcesData)==null?void 0:t.facets,"Desktop")}
          </form>
        </div>

        ${this.getModalDialog("filter-drawer-dialog-content","left",this.getFacetsHTML((l=this.resourcesData)==null?void 0:l.facets,"Mobile","filter-drawer-dialog-content"),this.getFilteredFacets(this.resourcesData.facets,"Mobile"),"drawer",this.textFilterResults,13,"!h4","!max-w-[22.5rem] !overflow-clip !text-t-foreground")}
        ${this.getModalDialog("sort-options-drawer-dialog-content","left",this.getSortHTML((s=this.resourcesData)==null?void 0:s.sortOptions,"Mobile"),o``,"drawer",this.textSort,13,"!h4","!max-w-[22.5rem]")}
      </aside>

      <div class="flex-grow" content-category-results="resources">
        <div>
          <div>
            <div
              id="content-grid-header-search"
              class="product-grid-header mb-sm flex flex-col md:mt-sm md:flex-row md:items-center md:justify-between md:gap-sm"
            >
              <div class="flex">
                <dialog-toggle
                  modal-id="filter-drawer-dialog-content"
                  class="w-full md:hidden"
                >
                  <button
                    class="flex h-button-height w-full items-center justify-center gap-2xs border border-t-border text-t-foreground"
                    aria-expanded="false"
                  >
                    <svg-icon
                      src="icon-filters"
                      class="block"
                      style="--icon-size: 25px;"
                    ></svg-icon>
                    <span class="text-utility-bold font-medium"
                      >${this.textFilter}</span
                    >
                  </button>
                </dialog-toggle>
                <dialog-toggle
                  modal-id="sort-options-drawer-dialog-content"
                  class="w-full md:hidden"
                >
                  <button
                    class="flex h-button-height w-full items-center justify-center gap-2xs border-y border-r border-t-border text-t-foreground"
                    aria-expanded="false"
                  >
                    <svg-icon
                      src="icon-sorting"
                      class="block"
                      style="--icon-size: 25px;"
                    ></svg-icon>
                    <span class="text-utility-bold font-medium"
                      >${this.textSort}</span
                    >
                  </button>
                </dialog-toggle>
                ${this.getSortHTML((r=this.resourcesData)==null?void 0:r.sortOptions,"Desktop")}
              </div>
              <span
                class="${window.brand=="NG"?"text-t-disabled":"text-t-foreground-secondary"} text-utility-regular max-md:mb-2xs max-md:mt-sm max-md:w-full max-md:px-pagegridmargin md:order-[-1]"
                >${(n=this.resourcesData)!=null&&n.totalResults?(((i=this.resourcesData)==null?void 0:i.totalResults)==1?this.dataResultsGridWithCountOne:this.dataResultsGridWithCountOther).replace("{{ count }}",`${(a=(u=this.resourcesData)==null?void 0:u.totalResults)==null?void 0:a.toLocaleString("en-US")}`):x}</span
              >
            </div>
            <div>
              <div
                class="grid gap-y-xs max-md:px-pagegridmargin md:grid-cols-2 md:gap-x-xs md:gap-y-md lg:grid-cols-4 lg:gap-y-7"
              >
                ${$(((c=this.resourcesData)==null?void 0:c.cards)??[],p=>p.id,p=>o`
                    <dynamic-card
                      handle="${p.handle}"
                      class="group/dynamic-card"
                      view="article-card"
                      query-type="article"
                      article-type="${this.type}"
                    >
                      <div
                        data-slot="article-card-skeleton"
                        class="relative grid w-full items-center gap-xs group-has-[a]/dynamic-card:hidden"
                      >
                        <div
                          data-slot="article-card-skeleton-image"
                          class="${window.brand=="NG"?"rounded-sm":""} block aspect-square animate-pulseskeleton overflow-clip bg-t-border"
                        ></div>
                        <div class="flex flex-col gap-2xs">
                          <div
                            data-slot="article-card-skeleton-caption"
                            class="${window.brand=="NG"?"rounded-sm":""} caption h-[1em] max-w-10 animate-pulseskeleton bg-t-border"
                          ></div>
                          <div
                            data-slot="article-card-skeleton-title"
                            class="${window.brand=="NG"?"rounded-sm":""} text-heading-6 h-[1em] max-w-[90%] animate-pulseskeleton bg-t-border font-medium leading-[1.2]"
                          ></div>
                          <div
                            data-slot="article-card-skeleton-exerpt"
                            class="${window.brand=="NG"?"rounded-sm":""} text-caption h-[1em] max-w-[80%] animate-pulseskeleton bg-t-border"
                          ></div>
                          <div
                            data-slot="article-card-skeleton-exerpt"
                            class="${window.brand=="NG"?"rounded-sm":""} text-caption h-[1em] max-w-[50%] animate-pulseskeleton bg-t-border"
                          ></div>
                        </div>
                      </div>
                    </dynamic-card>
                  `)}
              </div>
            </div>
            ${this.getPaginateHTML(this.resourcesData.paginationIds,this.currentPage)}
          </div>
        </div>
      </div>
    </search-results-section>`}};g([h({type:String,attribute:"data-sort"})],m.prototype,"textSort",2);g([h({type:String,attribute:"data-filter"})],m.prototype,"textFilter",2);g([h({type:String,attribute:"data-filter-counter"})],m.prototype,"textFilterCounter",2);g([h({type:String,attribute:"data-filters-counter"})],m.prototype,"textFiltersCounter",2);g([h({type:String,attribute:"data-see-result"})],m.prototype,"textDataSeeResult",2);g([h({type:String,attribute:"data-see-results"})],m.prototype,"textDataSeeResults",2);g([h({type:String,attribute:"data-hide-count"})],m.prototype,"textHideCount",2);g([h({type:String,attribute:"data-view-all-count"})],m.prototype,"textViewAllCount",2);g([h({type:String,attribute:"data-apply"})],m.prototype,"textApply",2);g([h({type:String,attribute:"data-clear-all"})],m.prototype,"textClearAll",2);g([h({type:String,attribute:"data-results-grid-with-count-one"})],m.prototype,"dataResultsGridWithCountOne",2);g([h({type:String,attribute:"data-results-grid-with-count-other"})],m.prototype,"dataResultsGridWithCountOther",2);g([h({type:String})],m.prototype,"type",2);g([h({type:Number})],m.prototype,"facetsCheckboxVisibleLimit",2);g([h({type:Number})],m.prototype,"currentPage",2);g([h({type:Number,attribute:"results-per-page"})],m.prototype,"resultsPerPage",2);g([h({type:Object})],m.prototype,"resourcesData",2);g([h({type:String})],m.prototype,"textFilterResults",2);m=g([j("resource-results")],m);
